import { CircularProgress } from '@material-ui/core';
import Spinner from 'click-controls/controls/spinner';
import type React from 'react';

const Fallback: React.FC<any> = () => {
  if (!!process.env.isClick) {
    return (
      <div className="float-left">
        <Spinner message="" />
      </div>
    );
  }

  return (
    <div className="flex-1-1">
      <CircularProgress />
    </div>
  );
};

export default Fallback;
